import blueCircle from 'assets/images/blue-white-circle.svg';
import greyCircle from 'assets/images/grey-circle.svg';
import {
    generateSeriesOptionsForPeerComparison,
    getGridOptionsForPeerComparison,
    getTitleOptionsForPeerComparison,
    getTooltipForPeerComparison,
    getXAxisOptionsForPeerComparison,
    getYAxisLabelsForPeerComparison,
    getYAxisOptionsForPeerComparison
} from 'utils/charts/chart';
import { PeerComparisonTooltipType } from 'types/types';

const teamScoreGraphic = {
    image: {
        type: 'image',
        style: {
            image: blueCircle
        },
        cursor: 'default',
        bottom: '3.5%',
        width: 12,
        height: 12,
        top: '94.5%',
        left: '27.5%'
    },
    text: {
        type: 'text',
        style: {
            text: 'Team Risk Score',
            font: '12px "Outfit" 400',
            fill: '#929292'
        },
        cursor: 'default',
        bottom: 10,
        left: '30.5%'
    }
};

const peerScoreGraphic = {
    image: {
        type: 'image',
        style: {
            image: greyCircle
        },
        cursor: 'default',
        bottom: 23,
        top: '94.5%',
        left: '48.5%'
    },
    text: {
        type: 'text',
        style: {
            text: 'Peer Risk Score (Region Level)',
            font: '12px "Outfit" 400',
            fill: '#929292'
        },
        cursor: 'default',
        bottom: 10,
        left: '51.5%'
    }
};

export const teamPeerComparisonChartOptions = (data) => {
    const scenarioScore = data
        ? [data.s4Score, data.s3Score, data.s2Score, data.s1Score]
        : [0, 0, 0, 0];
    const peerScore = data
        ? [
              data.s4PeerScore,
              data.s3PeerScore,
              data.s2PeerScore,
              data.s1PeerScore
          ]
        : [0, 0, 0, 0];
    const yAxisLabels = getYAxisLabelsForPeerComparison();

    return {
        title: getTitleOptionsForPeerComparison(),
        tooltip: getTooltipForPeerComparison(
            data,
            PeerComparisonTooltipType.team
        ),
        grid: getGridOptionsForPeerComparison(),
        xAxis: getXAxisOptionsForPeerComparison(),
        yAxis: getYAxisOptionsForPeerComparison(),
        series: generateSeriesOptionsForPeerComparison(
            'team',
            scenarioScore,
            peerScore
        ),
        graphic: [
            teamScoreGraphic.image,
            teamScoreGraphic.text,
            peerScoreGraphic.image,
            peerScoreGraphic.text,
            yAxisLabels.scenario1,
            yAxisLabels.scenario2,
            yAxisLabels.scenario3,
            yAxisLabels.scenario4
        ]
    };
};
